<div class="rbac-shell">
  <nav class="rbac-shell__tabs">
    <button
      *ngFor="let tab of tabs"
      type="button"
      class="rbac-shell__tab"
      [class.rbac-shell__tab--active]="activeTab === tab.key"
      (click)="setTab(tab.key)">
      {{ tab.label }}
    </button>
  </nav>

  <div class="rbac-shell__content">
    <app-role-management *ngIf="activeTab === 'roles'"></app-role-management>

    <app-module-management
      *ngIf="activeTab === 'modules'"
      (manageSubModules)="openSubModules($event)">
    </app-module-management>

    <app-submodule-management
      *ngIf="activeTab === 'submodules' && selectedModule"
      [module]="selectedModule"
      (back)="backToModules()"
      (manageInnerModules)="openInnerModules($event)">
    </app-submodule-management>

    <app-innermodule-management
      *ngIf="activeTab === 'innermodules' && selectedModule && selectedSubModule"
      [module]="selectedModule"
      [subModule]="selectedSubModule"
      (back)="backToSubModules()">
    </app-innermodule-management>
  </div>
</div>
